import { isEmpty } from '@utils/miscellaneous/objectHelpers';

const updateImiValues = (data, imi) => {

    if(isEmpty(imi)) return data;

    return {
        ...data,
        taxHousehold: {
            ...data.taxHousehold,
            householdMember: data.taxHousehold.householdMember.map(hhm => {
                const {
                    applicantGuid
                } = hhm;

                const matchedIMI = imi[applicantGuid];

                if (matchedIMI === undefined) {
                    console.error(`Immigration Data for applicant with GUID ${applicantGuid} is not found`);
                    return hhm;
                } else {
                    const { applicantGuid, ...restIMIData } = matchedIMI;
                    return {
                        ...hhm,
                        citizenshipImmigrationStatus: {
                            ...hhm.citizenshipImmigrationStatus,
                            citizenshipDocument: {
                                ...hhm.citizenshipImmigrationStatus.citizenshipDocument,
                                ...restIMIData
                            }
                        }
                    };
                }
            })
        }
    };
};

const updateSsnValues = (data, ssns) => {

    if(isEmpty(ssns)) return data;

    return {
        ...data,
        taxHousehold: {
            ...data.taxHousehold,
            householdMember: data.taxHousehold.householdMember.map(hhm => {
                const {
                    applicantGuid
                } = hhm;

                const matchedSSN = ssns[applicantGuid];

                if(matchedSSN === undefined) {
                    console.error(`SSN for applicant with GUID ${applicantGuid} is not found amid received SSNs`);
                    return hhm;
                } else {
                    return {
                        ...hhm,
                        socialSecurityCard: {
                            ...hhm.socialSecurityCard,
                            socialSecurityNumber: matchedSSN
                        }
                    };
                }
            })
        }
    };
};

export {
    updateImiValues,
    updateSsnValues
};